import React from 'react';
import FunctionButton from './FunctionButton'
import { connect } from 'react-redux'
import * as general from '../constants/General'
import PropTypes from 'prop-types'

class FunctionBar extends React.Component {
  render() {
    const licenseItem = {};
    if (this.props.licensestatus === true) {
      licenseItem.color = '#63b65e';
      licenseItem.status = 100;
    } else {
      licenseItem.color = '#ff6160';
      licenseItem.status = 200;
    }
    let style = {
      display: 'none'
    }
    if (this.props.functionbartype !== general.FUNCTIONBAR_NONE) {
      style = {
        display: 'block'
      }
    }

    const buttons = this.props.functionbaritems.map((item, i) => (
      {
        key: i,
        desc: item.description,
        color: item.color,
        type: item.type,
        itemid: item.itemid,
        itemparam: item.itemparam,
        status: item.status,
        statusmessage: item.statusmessage
      }
    ));
    
    if (this.props.functionbartype === 200) {
      let description = this.props.version;
      if (this.props.blackbox) {
        description = `FDM ${description}`;
      }
      buttons.push({
        key: -1,
        desc: description,
        color: licenseItem.color,
        status: licenseItem.status,
        type: 423
      })
    }

    const PRIORITY_TYPES = [
      general.FUNCTIONBAR_STATUS_PRINTER,
      general.FUNCTIONBAR_STATUS_SCALE,
      general.FUNCTIONBAR_STATUS_DRAWER,
      general.FUNCTIONBAR_FUNCTION_ZREPORT,
      general.FUNCTIONBAR_FUNCTION_XREPORT,
      general.FUNCTIONBAR_FUNCTION_XINFOREPORT,
      general.FUNCTIONBAR_FUNCTION_OBJECTREPORT,
      general.FUNCTIONBAR_FUNCTION_HISTORIE,
      general.FUNCTIONBAR_FUNCTION_ARTICLEREPORT,
      general.FUNCTIONBAR_FUNCTION_LICENSE,
      general.FUNCTIONBAR_FUNCTION_EXITTOWINDOWS,
      general.FUNCTIONBAR_FUNCTION_WORKIN,
      general.FUNCTIONBAR_FUNCTION_WORKOUT
    ];

    buttons.sort((a, b) => {
      const aPriority = PRIORITY_TYPES.indexOf(a.type);
      const bPriority = PRIORITY_TYPES.indexOf(b.type);
      if (aPriority === -1 && bPriority === -1) return 0;
      if (aPriority === -1) return 1;
      if (bPriority === -1) return -1;
      return aPriority - bPriority;
    });

    return (
      <div id="functionbar" className={this.props.cssClass} style={style}>
        {
          buttons.map(button =>
            <FunctionButton
              key={button.key}
              text={button.desc}
              color={button.color}
              type={button.type}
              itemid={button.itemid}
              itemparam={button.itemparam}
              status={button.status}
              statusmessage={button.statusmessage}
            />
          )
        }
      </div>)
  }
}

FunctionBar.propTypes = {
  functionbartype: PropTypes.number,
  functionbaritems: PropTypes.array.isRequired,
  licensestatus: PropTypes.bool.isRequired
}

function mapStateToProps(state) {
  return {
    functionbartype: state.layoutState.functionbartype,
    functionbaritems: state.layoutState.functionbaritems,
    licensestatus: state.generalState.licensestatus,
    version: state.generalState.version,
    blackbox: state.generalState.licenses.blackbox
  }
}

export default connect(mapStateToProps)(FunctionBar)



// WEBPACK FOOTER //
// src/components/FunctionBar.jsx